export const rootElementId = 'root';
export const scrollContainerId = 'scrollContainer';
